/**
 * O que a tela da Plataforma mostra/permite para o proprietário de uma empresa.
 * A decisão aqui só organiza a interface: quem decide de verdade é a API/banco
 * (proprietário ativo, convite pendente, empresa e permissão).
 */
import type { CompanyOwnerStatus, OwnerInvitationStatus } from "@cafegestor/shared";

export type OwnerView =
  /** já tem proprietário ativo: nada a fazer pela Plataforma */
  | { kind: "owner"; emails: string[] }
  /** convite pendente e válido: só dá para revogar */
  | { kind: "pending"; invitationId: string; email: string; expiresAt: string }
  /** sem proprietário e sem convite válido: pode emitir novo convite */
  | { kind: "issue"; last: { email: string; status: OwnerInvitationStatus } | null };

export const OWNER_INVITATION_LABEL: Record<OwnerInvitationStatus, string> = {
  pending: "Pendente",
  accepted: "Aceito",
  revoked: "Revogado",
  expired: "Expirado",
};

export function ownerView(owner: CompanyOwnerStatus, now: number = Date.now()): OwnerView {
  if (owner.ownerEmails.length > 0) return { kind: "owner", emails: owner.ownerEmails };
  const inv = owner.invitation;
  if (inv && inv.status === "pending" && Date.parse(inv.expiresAt) > now) {
    return { kind: "pending", invitationId: inv.id, email: inv.email, expiresAt: inv.expiresAt };
  }
  if (!inv) return { kind: "issue", last: null };
  // pendente já vencido aparece como expirado (continua no histórico)
  const status: OwnerInvitationStatus = inv.status === "pending" ? "expired" : inv.status;
  return { kind: "issue", last: { email: inv.email, status } };
}
